import jsdk from '../../jsdk';
import t from 'tcomb';
import UUID from '../../web/domain/UUID';
import Validation from '../../web/domain/Validation';
import Select_Other from '../../web/domain/Select_Other';
import Select_Render_As from '../../web/domain/Select_Render_As';
import get_bundle from '../../web/domain/get_bundle';
import Str_Schema from '../../web/domain/Str_Schema';
import Margin_Bottom_Style from '../../web/domain/style/Margin_Bottom_Style';


const Select_Component_Input = t.struct({
  id: UUID,
  style: Margin_Bottom_Style,
  options: t.list(t.tuple([t.Str, t.Str])),
  schema: Str_Schema,
  render_as: Select_Render_As,
  other: t.maybe(Select_Other),
  other_label: t.maybe(t.String)
}, 'Select_Component_Input');

/*
const Select_Component_Style = jsdk.Interface({
  'margin-bottom': jsdk.Maybe(Style_Distance)
});

export default function Select_Component_Input(id, style, options, schema, render_as, other) {
  jsdk.assert(jsdk.UUID.is(id));
  jsdk.assert(Select_Component_Style.is(style));
  jsdk.assert(jsdk.List(jsdk.Tuple([jsdk.Str, jsdk.Str])).is(options));
  jsdk.assert(jsdk.Str_Schema.is(schema));
  jsdk.assert(Select_Render_As.is(render_as));
  jsdk.assert(jsdk.Maybe(Select_Other).is(other));

  this.type = 'reducer/select';
  this.id = id;
  this.style = style;
  this.options = options;
  this.schema = schema;
  this.render_as = render_as;
  this.other = other;
  return jsdk.freeze(this);
}

Select_Component_Input.is = function(x) {
  return x instanceof Select_Component_Input;
};

Select_Component_Input.of = function(x) {
  jsdk.assert(jsdk.Obj.is(x));
  return new Select_Component_Input(
    jsdk.UUID.of(x.id),
    Select_Component_Style.of(x.style),
    jsdk.List(jsdk.Tuple([jsdk.Str, jsdk.Str])).of(x.options),
    jsdk.Str_Schema.of(x.schema),
    Select_Render_As.of(x.render_as),
    jsdk.Maybe(Select_Other).of(x.other)
  );
};
*/

Select_Component_Input.prototype.to_html = function(value, locale) {

  // i margini vanno sul contenitore
  var styles = jsdk.split_margins(this.style);

  var html = '';

  if (this.render_as === 'textbox') {

    html = jsdk.dom.textbox({
      id: this.id
    });

  } else {

    var bundle = get_bundle(locale).reducer;

    // faccio una copia in modo da non modificare l'originale
    var options = this.options.slice();

    // se c'è l'opziona altro aggiungo una option in ultima posizione
    if (this.other) {
      options.push([
        this.other.textbox_id,
        this.other_label || bundle.other
      ]);
    }

    if (this.render_as === 'radio') {
      html = jsdk.radio_group(options, this.id, {
        id: this.id,
        style: styles.other
      });
    } else {
      options.unshift(jsdk.EMPTY_OPTION);
      html = jsdk.dom.select_of_options(options, {
        id: this.id
      });
    }

    // se c'è l'opzione altro aggiungo la textbox
    if (this.other) {
      html += jsdk.dom.textbox({
        id: this.other.textbox_id
      });
    }

  }

  return jsdk.Form.wrap_input(this.id, html, styles.margins);

};

Select_Component_Input.prototype.focus = function() {

  // nel caso l'utente abbia già selezionato una opzione non metto il focus
  // questo evita di perdere il focus dalla textbox se c'è l'opzione altro
  if (this.other && this.input() === this.other.textbox_id) {
    return;
  }

  if (this.render_as === 'radio') {
    // se è un gruppo di radio metto il focus sulla prima
    $('#' + this.id + ' input[type=radio]:nth(0)').focus();
  } else {
    // altrimenti metto il focus sulla select o sulla textbox
    $('#' + this.id).focus();
  }

};

Select_Component_Input.prototype.input = function() {

  if (this.render_as === 'radio') {

    return $('#' + this.id + ' input[type=radio]:checked').val() || '';

  } else if (this.render_as === 'select') {

    return $('#' + this.id).val();

  } else {

    var text = $('#' + this.id).val();
    if (text) {
      var option = jsdk.find(this.options, function(option) {
        return option[1] === text;
      });
      return option ? option[0] : 'option_not_found';
    }
    return '';

  }

};

Select_Component_Input.prototype.set_error = function(message) {
  $("#" + this.id + "_error").html(message);
};

Select_Component_Input.prototype.value = function(locale) {
  //jsdk.assert(Locale.is(locale));
  // recupero il valore selezionato dall'utente e lo valido
  var input = this.input();
  var schema = this.schema;
  if (this.render_as === 'textbox') {
    schema = jsdk.copy(schema);
    schema.any = this.options.map(jsdk.prop(0));
    schema = jsdk.Str_Schema.of(schema);
  }
  var validation = schema.validate(input);

  if (validation.rule === null) {
    // se c'è l'opzione altro e se l'utente l'ha selezionata..
    if (this.other && input === this.other.textbox_id) {
      var textbox_id = this.other.textbox_id;
      // recupero il valore della textbox
      var textbox_value = $('#' + textbox_id).val();
      // valido la textbox
      var textbox_validation = this.other.schema.validate(textbox_value);
      if (textbox_validation.rule) {
        // se la textbox non va bene, gli metto il focus
        $('#' + textbox_id).focus();
        validation = textbox_validation;
      } else {
        // se invece è andato tutto bene, concateno i valori della radio e della textbox
        validation = new Validation({x: [
          [this.id, validation.x],
          [textbox_id, textbox_validation.x]
        ]});
      }
    } else {
      validation = new Validation({x: [
        [this.id, validation.x]
      ]});
    }
  }
  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
  return validation;
};


jsdk.Form.add_input('reducer/select', Select_Component_Input);


export default Select_Component_Input;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/form/reducer/Select_Component_Input.js
 **/